import type {ScribeArtifactsProps} from './types'

const EMPTY_ARTIFACTS: ScribeArtifactsProps['artifacts'] = []

export function ScribeArtifacts({
  artifacts = EMPTY_ARTIFACTS,
  emptyMessage = 'No Scribe artifacts yet.',
}: ScribeArtifactsProps) {
  return (
    <section aria-label="Scribe artifacts">
      <h2>Scribe artifacts</h2>
      {artifacts.length > 0 ? (
        <ul>
          {artifacts.map((artifact, index) => (
            <li key={artifact.id ?? `${artifact.type}-${artifact.name}-${index}`}>
              {artifact.name} ({artifact.type})
            </li>
          ))}
        </ul>
      ) : (
        <p>{emptyMessage}</p>
      )}
    </section>
  )
}

ScribeArtifacts.displayName = 'ScribeArtifacts'
